import { render, staticRenderFns } from "./ProjectEditor.vue?vue&type=template&id=332f2021&scoped=true&"
import script from "./ProjectEditor.vue?vue&type=script&lang=ts&"
export * from "./ProjectEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEditor.vue?vue&type=style&index=0&id=332f2021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332f2021",
  null
  
)

export default component.exports